<template>
  <div class="works-index">
    <Header></Header>
    <div class="works-content-box">
      <img class="works-banner" src="../assets/image/worksShow/banner.png" alt="" />
      <div class="container">
        <div class="current-box">
          <div class="current-item" @click="currentTab(1)" :class="{active:tabActive== 1}">全国优秀作品展示</div>
          <div class="current-item" @click="currentTab(2)" :class="{active:tabActive== 2}">院校优秀作品展示</div>
        </div>
        <div class="menu-box" v-show="tabActive == 1">
          <div :class="['menu-item', workId == 1 ? 'active' : '']" @click="changeMenu(1)">第一届</div>
          <div :class="['menu-item', workId == 2 ? 'active' : '']" @click="changeMenu(2)">第二届</div>
          <div :class="['menu-item', workId == 3 ? 'active' : '']" @click="changeMenu(3)">第三届</div>
          <div :class="['menu-item', workId == 4 ? 'active' : '']" @click="changeMenu(4)">第四届 </div>
          <div :class="['menu-item', workId == 5 ? 'active' : '']" @click="changeMenu(5)">第五届</div>
          <div :class="['menu-item', workId == 6 ? 'active' : '']" @click="changeMenu(6)">第六届</div>
          <div :class="['menu-item', workId == 7 ? 'active' : '']" @click="changeMenu(7)">第七届</div>
        </div>
        <img class="works-label" src="../assets/image/worksShow/label.png" />

        <template>
          <!-- 全国优秀作品展示 -->
          <div class="resource-lists" v-show="tabActive == 1">
            <template v-if="tableData && tableData.length > 0">
              <div v-for="(item, index) in tableData" :key="index" @click="workDetails(item)" class="resource-box">
                <div class="resource-img">
                  <!-- @error="handleImageError(item)" -->
                  <img :src="item.cover || defaultCover" class="inner_img" />
                </div>
                <div class="resource-txt">
                  <div class="title">{{ item.title }}</div>
                </div>
              </div>
              <div class="sub-visibility" v-for="i in 7" :key="i + 'v1'"></div>
            </template>
            <a-empty v-else></a-empty>
          </div>
          <!-- 院校优秀作品展示 -->
          <div class="resource-lists" v-show="tabActive == 2">
            <template v-if="caseData && caseData.length > 0">
              <div v-for="(item, index) in caseData" :key="index" @click="schoolDetails(item)" class="resource-box">
                <div class="resource-img">
                  <!-- @error="handleImageError(item)" -->
                  <img :src="item.cover || defaultCover" class="inner_img" />
                </div>
                <div class="resource-txt">
                  <div class="title">{{ item.title }}</div>
                </div>
              </div>
              <div class="sub-visibility" v-for="i in 7" :key="i + 'v1'"></div>
            </template>
            <a-empty v-else></a-empty>
          </div>
        </template>

        <a-pagination style="margin-top: 0;" v-model="page" :page-size="size" :total="totalNum" v-if="totalNum&&totalNum > 0" @change="pageChange" show-less-items />
      </div>
    </div>
  </div>
</template>

<script>
import Header from "../components/Header.vue";
import services from "../assets/js/services";
import workdata1 from "../assets/js/showsWork/data1.json";
import workdata2 from "../assets/js/showsWork/data2.json";
import workdata3 from "../assets/js/showsWork/data3.json";
import workdata4 from "../assets/js/showsWork/data4.json";
import workdata5 from "../assets/js/showsWork/data5.json";
import workdata6 from "../assets/js/showsWork/data6.json";
import workdata7 from "../assets/js/showsWork/data7.json";
import { mapState } from "vuex";
export default {
  components: {
    Header,
  },
  data () {
    return {
      workId: 7,
      services,
      workdata1,
      workdata2,
      workdata3,
      workdata4,
      workdata5,
      workdata6,
      workdata7,
      page: 1,
      size: 15,
      tableData: [],
      caseData: [], // 优秀案例列表
      totalNum: 0,
      schoolcode: localStorage.getItem("schoolCode"),
      defaultCover: require("../assets/image/worksShow/delfault.jpg"),// 默认封面图路径
      tabActive: 1,
      resType: 1,// 资源类型 1|2
    };
  },
  computed: {
    ...mapState({
      appsUserInfo: state => state.appsLogin.appsUserInfo,
    }),
  },
  mounted () {
    if (this.$route.query.id) {
      this.workId = this.$route.query.id;
    }
    if (this.$route.query.page) {
      this.page = Number(this.$route.query.page);
    }
    if (this.$route.query.type) {
      this.tabActive = this.$route.query.type
    }

    if (this.tabActive == 1) {
      this.getTableList(this.workId);
    } else {
      this.getCaseList()
    }
  },
  methods: {
    schoolDetails (item) {
      const targetRoute = this.$router.resolve({
        path: `/${this.schoolcode}/worksshow/detail`,
        query: {
          id: item.id
        }
      });
      window.open(targetRoute.href, '_blank');
    },
    async getCaseList () {
      let result = await services.getCasesList({ page: this.page, size: this.size, school_code: this.schoolcode })
      if (result.code == "0000") {
        this.caseData = result.data.items
        this.totalNum = result.data.total
      }
    },
    currentTab (val) {
      const query = {
        page: 1,
        type: val === 1 ? 1 : 2
      };

      if (val === 1) {
        query.id = this.workId;
      } else {
        query.id = ""
      }

      const routeUrl = this.$router.resolve({
        path: `/${this.schoolcode}/worksshow`,
        query
      });
      window.open(routeUrl.href, "_self");
    },
    getTableList (id) {
      let alldata = this["workdata" + id];
      this.totalNum = alldata.length;
      this.tableData = alldata.slice(
        (this.page - 1) * this.size,
        this.page * this.size
      );
    },
    pageChange (val) {
      this.page = val;
      if (this.tabActive == 1) {
        let routeUrl = this.$router.resolve({
          path: `/${this.schoolcode}/worksshow`,
          query: {
            id: this.workId,
            page: val,
            type: 1,
          },
        });
        window.open(routeUrl.href, "_self");
        //   this.getTableList(this.workId);
      } else {
        // this.getCaseList()
        let routeUrl = this.$router.resolve({
          path: `/${this.schoolcode}/worksshow`,
          query: {
            id: this.workId,
            page: val,
            type: 2,
          },
        });
        window.open(routeUrl.href, "_self");

      }
    },
    workDetails (item) {
      window.open(item.href, "_blank");
    },
    changeMenu (id) {
      this.page = 1;
      //   this.totalNum = 0;
      this.workId = id;
      let routeUrl = this.$router.resolve({
        path: `/${this.schoolcode}/worksshow`,
        query: {
          id: this.workId,
          page: 1,
        },
      });
      window.open(routeUrl.href, "_self");
      //   this.getTableList(id);
    },
    handleImageError (item) {
      // 替换为默认图片
      item.cover = this.defaultCover;
      this.$forceUpdate()
    }
  },
};
</script>

<style lang="less" scoped>
.container {
    width: 1600px;
    margin: 0 auto;
}
.works-index {
    width: 100%;
    margin: 0 auto;
    padding: 54px 0 0;
}
.works-content-box {
    padding: 0 0 40px;
    background: url('../assets/image/worksShow/bg.png') no-repeat center;
    background-size: cover;
    .works-banner {
        width: 100%;
        height: auto;
        margin-bottom: 24px;
    }
    .works-label {
        width: 1000px;
        height: auto;
        display: block;
        margin: 40px auto;
    }
    .current-box {
        display: flex;
        margin-bottom: 19px;
        .current-item {
            flex: 1;
            height: auto;
            aspect-ratio: 800/100;
            background: url('../assets/image/worksShow/qg.png') no-repeat center;
            text-align: center;
            align-content: center;
            font-weight: bold;
            font-size: 18px;
            color: #302e2f;
            cursor: pointer;
            line-height: 100px;
            &.active {
                color: #ffffff;
                background: url('../assets/image/worksShow/qg-active.png')
                    no-repeat center;
            }
            &:first-child {
                background: url('../assets/image/worksShow/yx.png') no-repeat
                    center;
                &.active {
                    background: url('../assets/image/worksShow/yx-active.png')
                        no-repeat center;
                }
            }
        }
    }
    .menu-box {
        display: flex;
        align-items: center;
        justify-content: space-between;
        .menu-item {
            cursor: pointer;
            width: 194px;
            height: 60px;
            background: #ffffff;
            line-height: 60px;
            text-align: center;
            font-weight: bold;
            font-size: 16px;
            color: #585858;
            &:hover {
                color: #a82822;
                background: #fffbf2;
            }
            &.active {
                color: #a82822;
                background: url('../assets/image/worksShow/active.png')
                    no-repeat center;
                background-size: 100% auto;
            }
        }
    }
}
.resource-lists {
    width: 100%;
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
    padding-bottom: 15px;
    .resource-box {
        flex: 0 0 280px;
        float: left;
        background: #fff;
        cursor: pointer;
        margin-bottom: 20px;
        position: relative;

        &:hover .resource-txt {
            background: #fff3f2;
            .title {
                color: #a82822;
            }
        }
        &:hover .resource-img .inner_img {
            transform: scale(1.1);
        }

        .resource-img {
            height: 155px;
            width: 100%;
            overflow: hidden;
            .inner_img {
                width: 100%;
                height: 100%;
                object-fit: cover;
                transition: all 0.8s;
            }
            .inner_name {
                color: #ca0808;
                font-size: 15px;
                font-weight: bold;
                width: 80%;
                text-shadow: rgba(255, 255, 255, 0.6) 1px 1px 2px;
                text-align: center;
                position: absolute;
                z-index: 9;
                left: 50%;
                top: 32%;
                transform: translate(-50%, -50%);
            }
        }
        .resource-txt {
            padding: 15px;
            width: 100%;
            box-sizing: border-box;
            background: #ffffff;
            border: 1px solid #e7eaec;
            .title {
                font-family: Microsoft YaHei;
                color: #3c3c3e;
                font-size: 13px;
                line-height: 20px;
                height: 40px;
                overflow: hidden;
                text-overflow: ellipsis;
                display: -webkit-box;
                -webkit-line-clamp: 2;
                -webkit-box-orient: vertical;
            }
        }
    }
    .sub-visibility {
        flex: 0 0 280px;
        display: inline-block;
        overflow: visible;
    }
}
@media screen and (max-width: 1600px) {
    .container {
        width: 1200px;
        margin: 0 auto;
    }
    .menu-box {
        .menu-item {
            cursor: pointer;
            width: 145.5px !important;
            height: 45px !important;
            line-height: 45px !important;
        }
    }
    .resource-box {
        flex: 0 0 210px !important;
        .resource-img {
            height: 118px !important;
        }
    }
    .sub-visibility {
        flex: 0 0 210px !important;
    }
}
</style>